import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Server_URL } from 'src/environments/environment';
import { environment } from 'src/environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class KeywordsService {
  public Data = new BehaviorSubject(null)
  constructor(private _HttpClient:HttpClient) { }

  Getkeywords():Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/Keyword/GetDB`);
  }
  GetkeywordsPaged(data:any):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/Keyword/GetPagedDB`,data);
  }
  Deletekeywords(id):Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/Keyword/Delete?id=${id}`);
  }
  Createkeywords(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/Keyword/Create`,data);
  }
  Updatekeywords(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/Keyword/Update`,data)
  }
}
